import React from 'react';
import {
  Col,
  Panel,
  Row,
} from 'react-bootstrap';
import { toNumber } from '../../../utils/numbers';
import { ManuallyAddedConstituents } from '../../../../types/api/ManualAdd';
import { useTranslation } from 'react-i18next';

const ManualAddList: ({ itemsToAdd, orderMixQuantity }: {
  itemsToAdd: Array<ManuallyAddedConstituents>;
  orderMixQuantity: number
}) => string | React.ReactNode = ({ itemsToAdd, orderMixQuantity }) => {
  const { t } = useTranslation();

  return !itemsToAdd?.length ? '' : (
    <>
      <strong>{t('Constituents To Be Manually Added')}</strong>
      <div className="manually-added-list">
        <Panel>
          <Panel.Body>
            <Row>
              <Col md={3}><strong>{t('Constituent')}</strong></Col>
              <Col md={3}><strong>{t('Quantity')}</strong></Col>
              <Col md={3}><strong>{t('Batch Size')}</strong></Col>
              <Col md={3}><strong>{t('Final Quantity')}</strong></Col>
            </Row>
            {itemsToAdd?.map((item: ManuallyAddedConstituents) => (
              <Row key={item.constituentItemCode}>
                <Col md={3}>{item.constituentItemCode}</Col>
                <Col md={3}>{item.quantity} {item.unitSymbol}</Col>
                <Col md={3}>{orderMixQuantity}</Col>
                <Col md={3}>
                  {toNumber(item.quantity*orderMixQuantity, 2)} {item.unitSymbol}
                </Col>
              </Row>
            ))}
          </Panel.Body>
        </Panel>
      </div>
    </>
  );
};

export default ManualAddList;
